import { Button } from '@/components';
import Tooltip from '@/components/tooltip';
import { useSolveQuestion } from '@/context/solve-question-context';

type Props = {
	onGetQuestions?: () => void;
	isSearchDisabled?: boolean;
	isAppointmentAvailable?: boolean;
};

const SolveQuestionDefaultState = ({ onGetQuestions, isSearchDisabled = false, isAppointmentAvailable = false }: Props) => {
	const { questionPool, remainingPassedQuestionCount, onOpenPassedQuestions, isNullablePassedQuestions } = useSolveQuestion();
	return (
		<div className={'solve-container'}>
			<div className={'solver-actions-container'}>
				<i className={'icons-user-circle'} />
				<div className="button-wrapper">
					{(isSearchDisabled || !questionPool || questionPool.length === 0) && <div className="disabled-text">Havuzda çözülmemiş soru bulunmamaktadır. Lütfen sonra tekrar deneyiniz.</div>}
					<Tooltip
						isVisible={isSearchDisabled}
						position={'top'}
						text={isAppointmentAvailable ? 'Aktif bir randevunuz yaklaştığı için aynı anda iki uygulama kullanılamaz.' : 'Şu anda bir arama yapıyorsunuz.'}>
						<Button
							onClick={onGetQuestions}
							disabled={isSearchDisabled || !questionPool || questionPool.length === 0}>
							<b>Soru Çözmeye Başla!</b>
						</Button>
					</Tooltip>
					{remainingPassedQuestionCount < 10 && (
						<Button
							onClick={onOpenPassedQuestions}
							variant="outline"
							disabled={isNullablePassedQuestions || isAppointmentAvailable}>
							<b>Pas Geçilen Sorular</b>
						</Button>
					)}
				</div>
			</div>
		</div>
	);
};

export default SolveQuestionDefaultState;
